import { useEffect } from 'react';

const useEventListener = (
  eventName,
  eventListener,
  element = document,
  dependency = [],
  conditionAdd = true,
  conditionRemove = true,
) => {
  useEffect(() => {
    const isSupported = element && element.addEventListener;
    if (!isSupported) return;

    if (conditionAdd) element.addEventListener(eventName, eventListener);

    return () => {
      if (conditionRemove) element.removeEventListener(eventName, eventListener);
    };
  }, [eventName, element, ...dependency]);
};

export default useEventListener;
